import { apiCMSWithToken } from './axios'

export const url = {
  config: `/config`
}

export async function getConfig(p = {}) {

  try {
    const params = new URLSearchParams({ ...p })
    const response = await apiCMSWithToken.get(
      `${url.config}/list-system-config?${params.toString()}`
    )
    return response
  } catch (error) {
    console.error('Error in postSearch:', error)
    throw error
  }
}

export async function detailConfig(id) {
  try {
    const response = await apiCMSWithToken.get(`${url.config}/detail-system-config?id=${id}`)
    return response
  } catch (error) {
    console.error('Error in postSearch:', error)
    throw error
  }
}


export async function configAdd(body) {
  const response = await apiCMSWithToken.post(`${url.config}/create-system-config`, body)
  return response
}

export async function configUpdate(body) {
  const response = await apiCMSWithToken.post(`${url.config}/update-system-config`, body)
  return response
}

export async function deleteConfig(id) {
  try {
    const response = await apiCMSWithToken.delete(`${url.config}/delete-system-config?id=${id}`)
    return response
  } catch (error) {
    console.error('Error in postSearch:', error)
    throw error
  }
}


export default {
  getConfig,
  configAdd,
  deleteConfig,
  detailConfig,
  configUpdate
}
